import { g as getProductsFromSectionRenderingAPI } from "./section-rendering-Bf2mDQN0.js";
import { g as getProductsFromStorefrontAPI } from "./storefront-Bthd_nt4.js";
import { g as getProductsFromKlevuAPI } from "./klevu-BVC2pWRs.js";
const API = "SECTION_RENDERING";
const getProducts = async (api = API, selectedFilters, pagination, selectedSort = "best-selling") => {
  switch (api) {
    case "SECTION_RENDERING":
      return getProductsFromSectionRenderingAPI(
        selectedFilters,
        selectedSort,
        pagination
      );
    case "STOREFRONT":
      return getProductsFromStorefrontAPI();
    case "BOOST":
    case "KLEVU":
      return getProductsFromKlevuAPI();
  }
};
export {
  getProducts as g
};
